import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgMessagingInactive = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 18 18"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            stroke="#BDBDBD"
            strokeWidth={1.125}
            d="M2.25 5.625a2.813 2.813 0 0 1 2.813-2.812h7.875a2.813 2.813 0 0 1 2.812 2.812v5.625a2.813 2.813 0 0 1-2.812 2.813H6.32c-.174 0-.347.04-.503.118L2.25 15.965z"
        />
    </svg>
)
const ForwardRef = forwardRef(SvgMessagingInactive)
const Memo = memo(ForwardRef)
export default Memo
